// JobsSection.js
import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
import { useModalContext } from "../../context/ModalContext";
import JobCenterViewer from "./JobCenterViewer";
import LeftSideBar, { FolderCollapse } from "../../components/SideBar/LeftSideBar";
import fileFolderConfig from "../../commonFunctions/fileFolderConfig";
import Navbar from "../../Layouts/Navbar/Navbar";
import { useTreeContext } from "../../context/TreeDataContext";
import { TryAgainMessage } from "../Screen/ScreenSection";
import { getTreeDataForJobs } from "../../utils/treeData/treeDataUtils";
import { deleteFolderOfFile, editFolderOrFile, insertNewFileOrFolder } from "../../utils/treeData/folderEditorUtils";

const JobsSection = () => {
  // const [explorerData, setExplorerData] = useState([]);
  const { jobsExplorerData, setJobsExplorerData } = useTreeContext();
  const [selectedScreen, setSelectedScreen] = useState({ id: "", name: "", parentData: "" });
  const { getUserConfirmationForDelete } = useModalContext();

  const [isLoader, setIsLoader] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchAllJobs = async () => {
    try {
      setIsLoader(true);
      const { data } = await axiosInstance.get(`/jobs`);
      const treeData = getTreeDataForJobs(data);
      setJobsExplorerData(treeData);
    } finally {
      setIsLoader(false);
    }
  };

  const handleNewInsert = async (folderId, name) => {
    try {
      const config = {
        name: name
      };
      const { data, message } = await axiosInstance.post(`/jobs`, config);
      const newItem = fileFolderConfig.getFileConfig(data.id, data.name, "jobs");

      const newTree = insertNewFileOrFolder(jobsExplorerData, folderId, newItem);
      setJobsExplorerData(newTree);
      setSelectedScreen({ id: data.id, name: data.name });
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleDelete = async (folder) => {
    try {
      const userConfirmed = await getUserConfirmationForDelete(folder.name);
      if (!userConfirmed) return;

      const { message } = await axiosInstance.delete(`/jobs/${folder.id}`);
      const newTree = deleteFolderOfFile(jobsExplorerData, folder);
      setJobsExplorerData(newTree);
      // setJobsExplorerData(newTree)
      if (folder.id === selectedScreen?.id) setSelectedScreen(false);

      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleEdit = async (folder, newName) => {
    try {
      const config = {
        name: newName
      };
      const { message } = await axiosInstance.put(`/jobs/${folder.id}`, config);

      const newTree = editFolderOrFile(jobsExplorerData, folder, newName);
      setJobsExplorerData(newTree);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const callbackFunction = (id, parentData, name) => {
    if (id === selectedScreen.id) return;
    setSelectedScreen({ id, name, parentData });
  };

  const initialFetching = async () => {
    setIsLoader(true);
    setIsError(false);
    try {
      if (jobsExplorerData && jobsExplorerData.length > 0) {
        setJobsExplorerData(jobsExplorerData);
      } else {
        // If not available, fetch the data from the API
        fetchAllJobs();
      }
    } catch (error) {
      setIsError(true);
    }
  };

  useEffect(() => {
    initialFetching();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <section className="main_section">
        <div className="sub_section">
          {isError ? (
            <TryAgainMessage retryFunction={initialFetching} />
          ) : (
            <>
              <div className="d_flex">
                <Navbar />
                <LeftSideBar
                  explorerData={jobsExplorerData}
                  setExplorerData={setJobsExplorerData}
                  selectedScreen={selectedScreen}
                  callbackFunction={callbackFunction}
                  handleNewInsert={handleNewInsert}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  type="Jobs"
                  isLoader={isLoader}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <FolderCollapse explorerData={jobsExplorerData} setExplorerData={setJobsExplorerData} type="jobs" />
                  </div>
                </LeftSideBar>
              </div>
              {selectedScreen.id && <JobCenterViewer selectedScreen={selectedScreen} />}
              <div style={{ boxShadow: "-2px 0 4px #E4E7EC" }}></div>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default JobsSection;
